import { Button } from "react-bootstrap";

import { LANDING_URL } from "@/constants/app";
import { EXTERNAL_ROUTES } from "@/constants/routes";
import { isWebView } from "@/constants/webView";
import useLocalizedHref from "@/hooks/useLocalizedHref";

interface ILogoProps {
  width?: number | string;
  height?: number | string;
}

function LogoLink({ width = 84, height = 40 }: ILogoProps) {
  const localizedHref = useLocalizedHref();

  return (
    <Button
      as="a"
      variant="link"
      href={
        !isWebView
          ? localizedHref(`${LANDING_URL}${EXTERNAL_ROUTES.HOME}`)
          : undefined
      }
      target={!isWebView ? "_blank" : undefined}
      className="p-0 position-relative z-1"
    >
      <img
        src="/assets/logo-link.svg"
        alt="Me-Short-Link Logo"
        width={width}
        height={height}
      />
    </Button>
  );
}

export default LogoLink;
